<template>
  <img
    :src="`/static/img/flags/${country}.svg`"
    class="flag-icon">
</template>

<script>
export default {
  name: 'Flag',
  props: {
    country: {
      type: String,
      default: 'us',
    },
  },
};
</script>
